// extracted by mini-css-extract-plugin
export default {"highlight":"adUT4"};